import { inject, Pipe } from '@angular/core';
import { Store } from '@ngxs/store';
import { JupiterState } from '../@store/state';
import { NewPermission } from '@core/enums';
import { PermissionSlot } from '../@store/types';

@Pipe({ name: 'jupiterPermissionSlot', standalone: true })
export class PermissionSlotPipe {
  store = inject(Store);

  transform(value: PermissionSlot): NewPermission {
    return this.store.selectSnapshot(JupiterState.getPermissionSlot(value));
  }
}
